"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_users(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3e2a4c57-9a45-4407-a688-4c6d24ccd5e5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131,140.93a153.85,153.85,0,0,1-31.29-3.2,7.25,7.25,0,0,1-5.53-8.93c5.86-22.9,21.65-33.58,37-33.58s30.74,10.69,36.53,33.6a7.25,7.25,0,0,1-5.53,8.9A153.85,153.85,0,0,1,131,140.93Zm22.9-68.68a23,23,0,1,0-23,23A23,23,0,0,0,153.87,72.25Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "52922737-c930-43c2-95cd-71719c1878f7",
    x1: 90.61,
    y1: 75.15,
    x2: 168.98,
    y2: 153.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "users-hi"), /*#__PURE__*/React.createElement("g", {
    id: "d2439e80-fd0a-4d3a-9d71-f68778f60468",
    "data-name": "users-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0e39201c-f201-4ec7-8710-b15f06607b45",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7e924ce4-d4bd-489d-bc97-966e41c43625",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "73eb66ef-c739-47e1-afd4-f055807a9aa9",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f187453b-6545-427b-ae93-364a2f409159",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "069e4800-1e95-481e-8ce1-3fbe93590ed7",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "faa3f382-47ca-48b2-b591-71db9fe6ec7a",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4533b371-9445-42eb-ae98-79f3e986c7ca",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "be5b66c4-b316-4b78-a393-345e1d01e73e",
    "data-name": "<Pfad>",
    cx: 130.89,
    cy: 72.25,
    r: 22.98,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "15a2fd34-8d27-49b5-ab43-754e981b2592",
    "data-name": "<Pfad>",
    d: "M162.12,137.73a7.25,7.25,0,0,0,5.53-8.9c-5.79-22.91-21.22-33.6-36.53-33.6s-31.1,10.68-37,33.58a7.25,7.25,0,0,0,5.53,8.93,153.85,153.85,0,0,0,31.29,3.2A153.85,153.85,0,0,0,162.12,137.73Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f2ed8d05-a91d-4f90-8482-b8d2f11de77a",
    "data-name": "<Pfad>",
    cx: 130.89,
    cy: 72.25,
    r: 22.98,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "d9852962-2fe5-4c58-9e0c-5b9aa3399c7b",
    "data-name": "<Pfad>",
    cx: 74.05,
    cy: 63.63,
    r: 31.35,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e2a4c57-9a45-4407-a688-4c6d24ccd5e5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "123.5 144 100.5 118.49 108.26 57.5 186.97 135.53 123.5 144",
    opacity: 0.2,
    fill: "url(#52922737-c930-43c2-95cd-71719c1878f7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "34266a5d-36e4-44d0-8fdd-5006e9326a79",
    "data-name": "<Pfad>",
    d: "M116.64,153a9.89,9.89,0,0,0,7.55-12.15C116.29,109.56,95.25,95,74.35,95s-42.43,14.58-50.43,45.81A9.89,9.89,0,0,0,31.46,153a209.9,209.9,0,0,0,42.68,4.37A209.9,209.9,0,0,0,116.64,153Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.71,94.07a23,23,0,0,0,30.16-21.82c0-.34,0-.67,0-1a23,23,0,0,1-45.9,0c0,.33,0,.66,0,1A23,23,0,0,0,123.71,94.07Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,129.61a7.22,7.22,0,0,1-5.68,6.12,153.87,153.87,0,0,1-31.15,3.2c-2.33,0-4.58-.06-6.79-.16l-.55,0c.19.67.37,1.34.55,2v.05a10.07,10.07,0,0,1,.25,1.47,9.94,9.94,0,0,0,0-1.51c2.12.09,4.27.15,6.49.15a153.87,153.87,0,0,0,31.15-3.2A7.24,7.24,0,0,0,167.8,129.61Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66,93.83a31.35,31.35,0,0,0,39.73-30.21c0-.34,0-.67,0-1a31.34,31.34,0,0,1-62.65,0c0,.33,0,.66,0,1A31.35,31.35,0,0,0,65.66,93.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,151a209.89,209.89,0,0,1-42.5,4.37A209.9,209.9,0,0,1,31.46,151a9.85,9.85,0,0,1-7.79-8.68A9.87,9.87,0,0,0,31.46,153a209.9,209.9,0,0,0,42.68,4.37,209.89,209.89,0,0,0,42.5-4.37,9.87,9.87,0,0,0,7.79-10.68A9.85,9.85,0,0,1,116.64,151Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))));
}

var _default = ic_users;
exports.default = _default;